export enum OverTime {
    AllFACILITY = 'allFac',
    MYFACILITY = 'myFac',
    NO = 'No'
}
